const IGNORE_JOB_ID_LIST = [172, 173, 266, 644, 651, 709];
const NOT_AVAILABLE_INFORMATION = "No information is available for this tab.";
const ZERO_VALUE = 0;

export { IGNORE_JOB_ID_LIST, ZERO_VALUE, NOT_AVAILABLE_INFORMATION };
